import React from 'react'
import { T } from '@transifex/react'
import { Text } from '@lightspeed/design-system-react'
import { IconInfoSolid24 } from '@lightspeed/unified-react-components'

export const PaymentRequestCancelledConfirmationBanner: React.FC = () => {
  return (
    <div className="payment-request-cancelled-confirmation-banner">
      <IconInfoSolid24 style={{ flexShrink: 0 }} />
      <Text style={{ lineHeight: '1.5' }}>
        <T
          _str="A payment was taken for this sale. Any pending payment requests have been automatically canceled."
          _context="Payment request cancelled confirmation banner"
        />
      </Text>
    </div>
  )
}
